import React, { useState } from 'react';
import { Autocomplete, InputAdornment, IconButton } from '@mui/material';
import GridPicker from './GridPicker';

// Drop-in for MUI <Autocomplete>: typing works as before; lists with 7+ options also get a grid browse button.
export default function GridAutocomplete(props) {
    const { gridColumns, gridRow, options, onChange, renderInput, getOptionLabel, minForGrid = 1, ...rest } = props;
    const [open, setOpen] = useState(false);
    const list = options || [];
    const labelOf = (o) => (getOptionLabel ? getOptionLabel(o) : typeof o === 'string' ? o : (o && (o.label || o.name)) || '');
    const useGrid = list.length >= minForGrid;
    const wrapInput = (params) => {
        const el = renderInput(params);
        if (!useGrid || !React.isValidElement(el)) return el;
        const ip = el.props.InputProps || params.InputProps || {};
        return React.cloneElement(el, {
            InputProps: {
                ...ip,
                endAdornment: (
                    <>
                        <InputAdornment position="end">
                            <IconButton size="small" title="Browse list" onClick={(e) => { e.stopPropagation(); setOpen(!open); }}>
                                <i className="fas fa-th-list" style={{ fontSize: 15 }}></i>
                            </IconButton>
                        </InputAdornment>
                        {ip.endAdornment}
                    </>
                )
            }
        });
    };
    return (
        <>
            <Autocomplete {...rest} options={list} getOptionLabel={getOptionLabel} onChange={onChange} renderInput={wrapInput} />
            {open && useGrid && (
                <GridPicker
                    rows={list.map((o, i) => ({ value: i, label: labelOf(o), ...(gridRow ? gridRow(o) : {}) }))}
                    columns={gridColumns || [{ key: 'label', label: 'Name', bold: true }]}
                    placeholder="Search…"
                    onClose={() => setOpen(false)}
                    onSelect={(r) => { setOpen(false); if (onChange) onChange({}, list[r.value], 'selectOption'); }}
                />
            )}
        </>
    );
}
